const AUTH0_CONNECTION_NAME_REGEX = /^[a-zA-Z0-9]+$/;

const validators = {
  validateAuth0ConnectionName(
    auth0ConnectionName: string | null | undefined,
  ): Record<string, string> {
    const errors: Record<string, string> = {};

    if (
      auth0ConnectionName &&
      !AUTH0_CONNECTION_NAME_REGEX.test(auth0ConnectionName)
    ) {
      errors["auth0_connection_name"] = "Use only letters and numbers";
    }

    return errors;
  },

  validateDateRange(
    startDate: string,
    endDate: string,
  ): Record<string, string> {
    const errors: Record<string, string> = {};

    if (startDate && endDate) {
      const startDateObj = new Date(startDate);
      const endDateObj = new Date(endDate);

      const startDay = Date.UTC(
        startDateObj.getUTCFullYear(),
        startDateObj.getUTCMonth(),
        startDateObj.getUTCDate(),
      );
      const endDay = Date.UTC(
        endDateObj.getUTCFullYear(),
        endDateObj.getUTCMonth(),
        endDateObj.getUTCDate(),
      );

      if (!isNaN(startDay) && !isNaN(endDay) && endDay <= startDay) {
        errors["end_at"] = "End date must be after the day of start date";
      }
    }

    return errors;
  },

  validateJsonPayload(payload: string): Record<string, string> {
    const errors: Record<string, string> = {};

    if (payload) {
      try {
        JSON.parse(payload);
      } catch {
        errors["payload"] = "Invalid JSON found";
      }
    }
    return errors;
  },

  validateMaxUserCount(
    maxUserCount: number | string | null | undefined,
  ): Record<string, string> {
    const errors: Record<string, string> = {};

    if (
      maxUserCount !== null &&
      maxUserCount !== undefined &&
      maxUserCount !== ""
    ) {
      const value = Number(maxUserCount);
      if (!Number.isInteger(value)) {
        errors["max_user_count"] = "Max User Count must be a whole number";
      } else if (value <= 0) {
        errors["max_user_count"] = "Max User Count must be greater than 0";
      }
    }

    return errors;
  },
};

export default validators;
